const getImage = (bgFilled: boolean, key: string): string => {
  return (import.meta as any).glob("./*.png", { eager: true })[
    `./${bgFilled ? "E-WEB-Goal" : "SDG_Icons_WEB"}-${key}.png`
  ].default;
};

export default getImage;
